<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const HeroDefaults = {
        "name": "hero",

        "outer-container": { 
            "style": {
                "text-align": "center",
                "align-items": "center",
                "z-index": "5",
            }
        },

        "heading": {
            "name": "heading",
            "style": {},
            "innerText": "Heading"
        },
        
        "subheading": {
            "name": "subheading",
            "style": {},
            "innerText": "this is cool"
        },
        "image": {
            "name": "image",
            "style": {
                "width": "30%", 
                "height": "auto", 
                "border-radius": "0px",
                "margin-bottom": "10px"
            },
            "src": "../static/image/rocket.png"
        },
        "meta": {
            "order": {
                "image": 0,
                "heading": 1,
                "subheading": 2,
            }
        }
    }
    
</script>

<script>


</script>

        
<img data-i-name="image"/>
<h1 data-i-name="heading"/>
<p data-i-name="subheading"/>

<style> 

</style>